var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-universal-footer"},[(_vm.isCtaShowing && !_vm.isParticipantEmbed)?_c(_vm.ctaComponent,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }